import {useCallback, useState} from 'react';
import {commitTicketingMutation} from '../../../graphql/forecastRelay';
import DismissTicketAiSuggestedActionMutation from '../../../../../mutations/ticketing/tickets/dismissTicketAiSuggestedActionMutation';

interface Options {
	onCompleted?: () => void;
	onError?: (error: Error) => void;
}

export function useDismissSuggestedAction(options?: Options) {
	const [inFlight, setInFlight] = useState(false);

	const dismiss = useCallback(
		(ticketId: string, actionId: string) => {
			setInFlight(true);
			commitTicketingMutation(
				DismissTicketAiSuggestedActionMutation,
				{ticketId, actionId},
				() => {
					setInFlight(false);
					options?.onCompleted?.();
				},
				error => {
					setInFlight(false);
					options?.onError?.(error instanceof Error ? error : new Error(String(error)));
				}
			);
		},
		[options]
	);

	return {dismiss, inFlight};
}
